import type { SVGProps } from "react";
export interface CodeQrScanIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CodeQrScanIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CodeQrScanIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18v-2a1.125 1.125 0 0 1 2.25 0v2c0 1.035.84 1.875 1.875 1.875h2l.115.006a1.125 1.125 0 0 1 0 2.238L8 22.125H6A4.125 4.125 0 0 1 1.875 18m18 0v-2a1.125 1.125 0 0 1 2.25 0v2A4.125 4.125 0 0 1 18 22.125h-2a1.125 1.125 0 0 1 0-2.25h2c1.035 0 1.875-.84 1.875-1.875m-18-10V6A4.125 4.125 0 0 1 6 1.875h2l.115.006a1.125 1.125 0 0 1 0 2.238L8 4.125H6c-1.036 0-1.875.84-1.875 1.875v2a1.125 1.125 0 0 1-2.25 0m18 0V6c0-1.036-.84-1.875-1.875-1.875h-2a1.125 1.125 0 0 1 0-2.25h2A4.125 4.125 0 0 1 22.125 6v2a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="m10 15.876.116.005a1.125 1.125 0 0 1 0 2.239l-.116.005h-.01a1.126 1.126 0 0 1 0-2.25zm7-3c.622 0 1.125.503 1.125 1.125v3c0 .62-.504 1.124-1.125 1.124h-3A1.125 1.125 0 0 1 12.877 17v-3c0-.62.503-1.124 1.125-1.124h3ZM5.875 15.5V14c0-.622.504-1.125 1.125-1.125h3a1.125 1.125 0 0 1 0 2.25H8.125v.375a1.125 1.125 0 0 1-2.25 0m9.25.375h.75v-.75h-.75zM10 5.875c.621 0 1.125.504 1.125 1.125v3c0 .621-.504 1.125-1.125 1.125H7A1.125 1.125 0 0 1 5.875 10V7l.006-.116A1.125 1.125 0 0 1 7 5.875zM12.876 10v-.01a1.125 1.125 0 0 1 2.25 0V10a1.125 1.125 0 0 1-2.25 0m3 0V8.125H14a1.125 1.125 0 0 1 0-2.25h3c.62 0 1.124.504 1.124 1.125v3a1.125 1.125 0 0 1-2.25 0ZM8.125 8.875h.75v-.75h-.75z"
      />
    </svg>
  );
}
